// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class StartTurnAction implements flatbuffers.IUnpackableObject<StartTurnActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):StartTurnAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsStartTurnAction(bb:flatbuffers.ByteBuffer, obj?:StartTurnAction):StartTurnAction {
  return (obj || new StartTurnAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsStartTurnAction(bb:flatbuffers.ByteBuffer, obj?:StartTurnAction):StartTurnAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new StartTurnAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.GameStartTurn;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

static startStartTurnAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.GameStartTurn);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt16(1, playerId, 0);
}

static endStartTurnAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createStartTurnAction(builder:flatbuffers.Builder, type:ActionType, playerId:number):flatbuffers.Offset {
  StartTurnAction.startStartTurnAction(builder);
  StartTurnAction.addType(builder, type);
  StartTurnAction.addPlayerId(builder, playerId);
  return StartTurnAction.endStartTurnAction(builder);
}

unpack(): StartTurnActionT {
  return new StartTurnActionT(
    this.type(),
    this.playerId()
  );
}


unpackTo(_o: StartTurnActionT): void {
  _o.type = this.type();
  _o.playerId = this.playerId();
}
}

export class StartTurnActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.GameStartTurn,
  public playerId: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return StartTurnAction.createStartTurnAction(builder,
    this.type,
    this.playerId
  );
}
}
